/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Fe_Location_TitleInputs */

const en_ticket_fe_location_title = /** @type {(inputs: Ticket_Fe_Location_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field engineer location`)
};

const ja_ticket_fe_location_title = /** @type {(inputs: Ticket_Fe_Location_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`技術者の現在地`)
};

const fr_ticket_fe_location_title = /** @type {(inputs: Ticket_Fe_Location_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position du technicien`)
};

const de_ticket_fe_location_title = /** @type {(inputs: Ticket_Fe_Location_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort des Servicetechnikers`)
};

/**
* | output |
* | --- |
* | "Field engineer location" |
*
* @param {Ticket_Fe_Location_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_fe_location_title = /** @type {((inputs?: Ticket_Fe_Location_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Fe_Location_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_fe_location_title(inputs)
	if (locale === "ja") return ja_ticket_fe_location_title(inputs)
	if (locale === "fr") return fr_ticket_fe_location_title(inputs)
	return de_ticket_fe_location_title(inputs)
});